import { PracticeModel } from './practiceModel';
import { practiceConnectApi } from '../practiceConnectApi';
import { AxiosResponse } from 'axios';
import constants from '../../../../utils/constants';

export const getPracticesBySapId = (sapId: string, invoicePrice: number, application?: string): Promise<AxiosResponse<PracticeModel[]>> => {
  return practiceConnectApi.get(`${constants.PROJECT_CONNECT_API_BASE_URL}/v1/practices`, { params: { sapId, invoicePrice, application } });
};
